<template>
  <div class="certifications-section">
    <div class="container">
      <div class="certifications-section-icon">
        <span class="icon-license"></span>
      </div>
      <h2>Certifications</h2>
      <ul class="list-unstyled">
        <li>Nesta Certified Personal Trainer</li>
        <li>Nesta Certified Fitness Nutrition Coach</li>
        <li>Nesta Certified MMA Conditioning Coach</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
@import '../assets/scss/beach-built/imports';

.certifications-section {
  color: $white;
  text-align: center;
  padding: rem(100) 0;
  background: $bb-gray-dark;
  @include gradient-directional($bb-gray-dark, lighten($bb-gray-dark, 4%), 150deg);

  h1, h2, h3, h4, h5, h6,
  .h1, .h2, .h3, .h4, .h5, .h6 {
    color: $white;
  }

  h2 {
    font-size: rem(40);
    margin: 0 0 rem(20) 0;
  }

  .certifications-section-icon {
    border-radius: 50%;
    display: inline-block;
    line-height: .8;
    text-align: center;
    padding: 1.5rem;
    margin: 0 0 rem(20) 0;
    border: 2px solid $white;

    [class*=icon-] {
      font-size: rem(40);
      // color: $bb-gray-dark;
    }
  }

  ul {
    li {
      margin: 0 0 rem(10) 0;
    }
  }

}

</style>
